import { useRequestGetUserTransactions } from '@/hooks/httpRequest';
import { IBroadcastCommandEventOption } from '@/interfaces';
import { useDocumentTitle, useUrlParams } from '../hooks';
import { broadcastService } from '@/services';
import PanelInfo from '../../PanelInfo';
import { Podcast } from 'lucide-react';
import DataTable from './dataTable';
import HeaderPage from './HeaderPage';
import { useEffect } from 'react';

import { useProfileUserStore } from '../store/profileUserStore';

const ProfileDetailUserDataTransactions = ({ userId }: { userId: string }) => {
	const { userData } = useProfileUserStore();

	const { limit, page, sortBy, sortType } = useUrlParams();
	const { data, userTransactions, isLoadingUserTransactions, userTransactionsUpdatedAt } = useRequestGetUserTransactions(
		{
			userId,
			config: {
				staleTime: 1000 * 60 * 60
			},
			limit,
			page,
			sortBy,
			sortType
		},
		!!userId
	);

	/* eslint-disable-next-line @typescript-eslint/consistent-type-assertions */
	useDocumentTitle({ userData: userData as any, transactions: userTransactions });

	useEffect(() => {
		broadcastService.publish({
			type: 'events',
			payload: {
				type: 'userTransactionsLoaded',
				data: userTransactions
			} as IBroadcastCommandEventOption
		});
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [userTransactionsUpdatedAt]);

	if (userTransactions.length === 0 && !isLoadingUserTransactions && data !== undefined) {
		return (
			<div className="flex flex-col space-y-4">
				<HeaderPage isLoading={isLoadingUserTransactions} />
				<PanelInfo
					title={'Aucune transaction trouvée.'}
					description={`Cet utilisateur n'a éffectuée aucune transaction jusqu'à présent.`}
					className="py-10 md:py-26 border-none"
					icon={Podcast}
				/>
			</div>
		);
	}

	return (
		<div className="flex flex-col space-y-4 animate__animated animate__fadeIn">
			<HeaderPage isLoading={isLoadingUserTransactions} />
			<DataTable
				transactions={userTransactions}
				pageCount={data?.pagination?.pageCount ?? 0}
				isLoading={isLoadingUserTransactions}
			/>
		</div>
	);
};

export default ProfileDetailUserDataTransactions;
